<!-- @format -->

<template>
  <div>
    <div class="ui segment">
      <div class="ui grid">
        <div class="ui row">
          <div class="twelve wide column">
            <h1 class="ui sub header">
              <span style="font-size: large"> Projected Balances </span>
            </h1>
            <span class="ui">hover over graph for detail</span>
          </div>
          <div class="four wide column" style="font-size: small">
            <div
              class="ui mini toggle checkbox"
              style="float: right !important; font-size: 10px"
            >
              <input
                type="checkbox"
                @change="adjustInflation"
                v-model="adjustForInflation"
              />
              <label
                >{{
                  !adjustForInflation ? "Show" : "Hide"
                }}
                inflation-adjusted</label
              >
            </div>
          </div>
        </div>

        <div class="ui row">
          <div class="two wide column" style="border-right: 1px solid grey">
            <h1 class="ui sub header">
              <span style="font-size: 1.3em" v-if="selectedAge">
                <AnimatedNumber
                  :startNumber="selectedAge.year"
                  :number="selectedAge.year"
                  :fmt="'0,0'"
                />
              </span>
            </h1>
            <span class="ui" style="font-size: 0.85em"> age </span>
          </div>
          <div
            v-if="highlightRangeDto == 'Median'"
            class="four wide column"
            style="border-right: 1px solid grey"
          >
            <h1 class="ui sub header">
              <span style="font-size: 1.3em" v-if="selectedAge">
                {{ shortCurrency }}
                <AnimatedNumber
                  :startNumber="
                    highlightLessLikelyRange
                      ? selectedAge.balance
                      : selectedAge.balance
                  "
                  :number="
                    highlightLessLikelyRange
                      ? selectedAge.balance
                      : selectedAge.balance
                  "
                  :fmt="'0,0.00a'"
                />
              </span>
            </h1>
            <span class="ui" style="font-size: 0.85em">
              <div
                v-if="highlightLessLikelyRange"
                class="box lesslikely"
                style="background-color: black; opacity: 1"
              ></div>
              <div
                v-else
                class="box"
                style="background-color: black; opacity: 1"
              ></div>
              median
              <span v-if="adjustForInflation">& adjusted for inflation</span>
            </span>
          </div>
          <div
            v-if="highlightRangeDto != 'Median'"
            class="four wide column"
            style="border-right: 0px solid grey"
          >
            <h1 class="ui sub header">
              <span style="font-size: 1.3em" v-if="selectedAge">
                {{ shortCurrency }}
                <AnimatedNumber
                  :startNumber="
                    highlightLessLikelyRange
                      ? selectedAge.balancePessimisticValue2
                      : selectedAge.balancePessimisticValue3
                  "
                  :number="
                    highlightLessLikelyRange
                      ? selectedAge.balancePessimisticValue2
                      : selectedAge.balancePessimisticValue3
                  "
                  :fmt="'0,0.00a'"
                />
              </span>
            </h1>
            <span class="ui" style="font-size: 0.85em">
              <div
                v-if="highlightLessLikelyRange"
                class="box lesslikely"
                :style="'border-color: black; opacity: 1;background-color: black'"
              ></div>
              <div
                v-else
                class="box"
                :style="'border-color: black; opacity: 1;background-color: black'"
              ></div>
              {{ toLowerText(bottomLineLabel) }}
              <span v-if="adjustForInflation">& adjusted for inflation</span>
            </span>
          </div>
          <div
            v-if="false"
            class="four wide column"
            style="border-right: 1px solid grey"
          >
            <h1 class="ui sub header">
              <span style="font-size: 1.3em" v-if="selectedAge">
                {{ shortCurrency }}
                <AnimatedNumber
                  :startNumber="
                    highlightLessLikelyRange
                      ? selectedAge.balanceOptimisticValue2
                      : selectedAge.balanceOptimisticValue3
                  "
                  :number="
                    highlightLessLikelyRange
                      ? selectedAge.balanceOptimisticValue2
                      : selectedAge.balanceOptimisticValue3
                  "
                  :fmt="'0,0.00a'"
                />
              </span>
            </h1>
            <span class="ui" style="font-size: 0.85em">
              <div
                v-if="highlightLessLikelyRange"
                class="box lesslikely"
                :style="
                  'opacity:' +
                  appearanceSettings.appearanceSchema.graphColorOpacity2 +
                  ';background-color: ' +
                  appearanceSettings.appearanceSchema.graphColorRange2
                "
              ></div>
              <div
                v-else
                class="box"
                :style="
                  'opacity:' +
                  appearanceSettings.appearanceSchema.graphColorOpacity +
                  ';background-color: ' +
                  appearanceSettings.appearanceSchema.graphColor
                "
              ></div>
              upper projected outcome
              <span v-if="adjustForInflation">& adjusted for inflation</span>
            </span>
          </div>
          <div class="six wide column">
            <div>
              <div
                :class="
                  'box big selectable ' +
                  (highlightLessLikelyRange ? 'selected' : 'unselected')
                "
                :style="
                  'opacity: 1' +
                  appearanceSettings.appearanceSchema.graphColorOpacity +
                  ';background-color: ' +
                  (highlightRangeDto == 'Median' ? 'black' : 'lightgray')
                "
              ></div>
              <a
                href="#"
                @click.prevent="highlightRange('Median')"
                :class="
                  highlightRangeDto == 'Median' ? 'selected' : 'unselected'
                "
              >
                Median </a
              ><strong v-if="highlightRangeDto == 'Median'">
                <i class="ui icon angle double left"></i>
              </strong>
              <br />
              <div
                :class="
                  'box big selectable ' +
                  (highlightLessLikelyRange ? 'selected' : 'unselected')
                "
                :style="
                  'opacity: ' +
                  appearanceSettings.appearanceSchema.graphColorOpacity +
                  ';background-color: ' +
                  (highlightRangeDto == 'More Likely'
                    ? 'black'
                    : appearanceSettings.appearanceSchema.graphColor)
                "
              ></div>
              <a
                href="#"
                @click.prevent="highlightRange('More Likely')"
                :class="
                  highlightRangeDto == 'More Likely' ? 'selected' : 'unselected'
                "
              >
                Bottom {{ moreLikelyText }} </a
              ><strong v-if="highlightRangeDto == 'More Likely'">
                <i class="ui icon angle double left"></i>
              </strong>
              <br />
              <div
                class="box big lesslikely selectable"
                :style="
                  highlightRangeDto != 'Less Likely'
                    ? 'opacity: ' +
                      appearanceSettings.appearanceSchema.graphColorOpacity2 +
                      ';background-color: ' +
                      appearanceSettings.appearanceSchema.graphColorRange2
                    : 'opacity: 1; background-color: black'
                "
              ></div>
              <a
                href="#"
                @click.prevent="highlightRange('Less Likely')"
                :class="highlightRangeDto == 'Less Likely' ? 'selected' : ''"
              >
                Bottom {{ lessLikelyText }} </a
              ><strong v-if="highlightRangeDto == 'Less Likely'">
                <i class="ui icon angle double left"></i>
              </strong>
            </div>
          </div>
        </div>
      </div>
      <br />
      <br />

      <dx-chart
        v-if="show"
        ref="chart"
        id="chart"
        style="height: 270px"
        title
        :data-source="chartProjections"
        :customize-point="customizePoint"
      >
        <dx-common-series-settings
          :type="type"
          value-field="value"
          argument-field="year"
          :grid="{ visible: false }"
        />
        <dx-common-axis-settings :color="colors.graph.axisColor">
          <dx-grid :color="colors.graph.axisGridColor" />
          <dx-label>
            <dx-font :color="colors.graph.fontColor" />
          </dx-label>
        </dx-common-axis-settings>
        <dx-argument-axis
          :value-margins-enabled="false"
          discrete-axis-division-mode="crossLabels"
        >
          <dx-label>
            <dx-font :color="colors.graph.fontColor" />
          </dx-label>
          <dx-constant-line
            :visible="projectionRequest.goalInfo.goalHasTarget"
            :value="
              projectionRequest.goalInfo.goalHasTarget
                ? projectionRequest.goalInfo.goalTargetAge
                : 0
            "
          >
            <DxLabel
              :text="
                '<strong>Goal</strong><br/> ' +
                this.shortCurrency +
                formatNr(projectionRequest.goalInfo.goalTarget, '0,0.0a')
              "
            />
          </dx-constant-line>

          <dx-constant-line
            v-show="hasAdhocCashFlow"
            :visible="hasAdhocCashFlow && adhocCashFlows.adhocCashFlow1 != 0"
            :value="
              adhocCashFlows.adhocCashFlow1 != 0
                ? adhocCashFlows.adhocCashFlowAge1
                : 0
            "
          >
            <DxLabel
              :text="
                'Adhoc CF ' +
                this.shortCurrency +
                formatNr(adhocCashFlows.adhocCashFlow1)
              "
            />
          </dx-constant-line>

          <dx-constant-line
            v-show="hasAdhocCashFlow"
            :visible="hasAdhocCashFlow && adhocCashFlows.adhocCashFlow2 != 0"
            :value="
              adhocCashFlows.adhocCashFlow2 != 0
                ? adhocCashFlows.adhocCashFlowAge2
                : 0
            "
          >
            <DxLabel
              :text="
                'Adhoc CF ' +
                this.shortCurrency +
                formatNr(adhocCashFlows.adhocCashFlow2)
              "
            />
          </dx-constant-line>
          <dx-tick :visible="false"></dx-tick>
          <dx-grid :visible="false" />
        </dx-argument-axis>
        <dx-value-axis :visible="false" position="right">
          <dx-grid opacity="0.3" :color="colors.graph.fontColor"></dx-grid>
          <dx-label :visible="true"></dx-label>
        </dx-value-axis>
        <dx-legend
          :visible="true"
          vertical-alignment="middle"
          horizontal-alignment="left"
          position="outside"
          item-text-position="inside"
        >
          <dx-font :color="colors.graph.fontColor" />
        </dx-legend>
        <DxCrosshair
          :horizontal-line="{ visible: false }"
          :enabled="true"
          :width="3"
          color="#949494"
          dash-style="dot"
        >
          <DxLabel :visible="false"></DxLabel>
        </DxCrosshair>

        <dx-series
          v-if="!onlyShowMoreLikelyOutcomes"
          :color="appearanceSettings.appearanceSchema.graphColorRange2"
          argument-field="year"
          value-field="medianAmount"
          name="Less likely"
          range-value1-field="balancePessimisticValue2"
          :range-value2-field="
            hideOptimistic ? 'balance' : 'balanceOptimisticValue2'
          "
          type="rangearea"
          :opacity="
            appearanceSettings.appearanceSchema.graphColorOpacity2 || 0.25
          "
        />
        <dx-series
          :color="appearanceSettings.appearanceSchema.graphColor"
          argument-field="year"
          value-field="medianAmount"
          name="More likely"
          range-value1-field="balancePessimisticValue3"
          :range-value2-field="
            hideOptimistic ? 'balance' : 'balanceOptimisticValue3'
          "
          type="rangearea"
          :opacity="
            appearanceSettings.appearanceSchema.graphColorOpacity || 0.35
          "
        />
        <dx-series
          argument-field="year"
          :color="'black'"
          :value-field="bottomLineValue"
          :name="bottomLineLabel"
          type="line"
        />
        <dx-series
          v-if="false"
          argument-field="year"
          color="black"
          value-field="balance"
          name="Median"
          type="line"
        />
        <dx-series
          v-if="false"
          argument-field="year"
          color="darkblue"
          value-field="cumulativeContribution"
          name="Contribution"
          type="line"
        />

        <dx-margin :bottom="20" />
        <dx-tooltip
          :enabled="true"
          :visible="false"
          :customize-tooltip="customizeTooltipBalances2"
        />
      </dx-chart>
      <div class="ui fields">
        <small style="text-align: right; margin-right: 25px">
          See
          <a href="#" @click.prevent="clickDisclaimer"
            >here how we calculate projected balances</a
          ></small
        >
        <br />
        <br />
      </div>
      <div v-if="false" class="ui fields">
        <div class="ui checkbox" style="float: right">
          <input type="checkbox" v-model="hideOptimistic" />
          <label>Hide optimistic projections?</label>
        </div>
        <br />
        <br />
      </div>
      <div v-if="false" class="ui fields">
        <div class="ui checkbox" style="float: right">
          <input type="checkbox" v-model="onlyShowMoreLikelyOutcomes" />
          <label>Only show More likely outcomes?</label>
        </div>
        <br />
        <br />
      </div>
      <Section>
        <div class="ui attached message" v-if="highlightRangeDto == 'Median'">
          <span
            class="box bhead"
            :style="'opacity: 1;background-color: black'"
          ></span>
          <strong>Median</strong> outcome
        </div>
        <div
          class="ui attached message"
          v-if="highlightRangeDto == 'More Likely'"
        >
          <span
            class="box bhead"
            :style="
              'opacity:' +
              appearanceSettings.appearanceSchema.graphColorOpacity +
              ';background-color: ' +
              appearanceSettings.appearanceSchema.graphColor
            "
          ></span>
          <strong>More Likely</strong> range of outcomes
        </div>
        <div
          class="ui attached message"
          v-if="highlightRangeDto == 'Less Likely'"
        >
          <span
            class="box bhead lesslikely"
            :style="
              'opacity:' +
              appearanceSettings.appearanceSchema.graphColorOpacity2 +
              ';background-color: ' +
              appearanceSettings.appearanceSchema.graphColorRange2
            "
          ></span>
          <strong>Less Likely</strong>
          range of outcomes
        </div>
        <div class="ui attached padded segment">
          <div class="ui">
            <div class="ui row">
              <div class="sixteen wide column">
                <div class="ui" v-if="chartProjections">
                  <span
                    class="ui"
                    v-if="
                      chartProjections &&
                      projectionRequest.goalInfo.goalHasTarget
                    "
                  >
                    <span
                      v-if="selectedLineValuesObject.goalTargetPercentage < 1"
                    >
                      <strong>
                        <i class="x icon" style="color: red"></i>
                        Goal.
                      </strong>
                      About
                      {{
                        formatNr(
                          selectedLineValuesObject.goalTargetPercentage,
                          "0.0%"
                        )
                      }}

                      of the goal's target will be met by age
                      {{ projectionRequest.goalInfo.goalTargetAge }}
                    </span>
                    <span v-else>
                      <strong>
                        <i
                          class="check square outline icon"
                          style="color: darkgreen"
                        ></i>
                        Goal.
                      </strong>
                      The <span class="box"></span>
                      {{ toLowerText(bottomLineLabel) }} projected outcome will
                      meet the target goal of {{ shortCurrency
                      }}{{ formatNr(projectionRequest.goalInfo.goalTarget) }}
                    </span>
                  </span>
                  <span
                    class="ui"
                    v-if="chartProjections && highlightRangeDto == 'Median'"
                  >
                    <span
                      v-if="
                        filter(chartProjections, {
                          balance: 0,
                        }).length > 0
                      "
                    >
                      <strong>
                        <i class="x icon" style="color: red"></i>
                      </strong>
                      The <strong>median outcome</strong> sees your money
                      lasting until age
                      {{
                        filter(chartProjections, {
                          balance: 0,
                        })[0].year
                      }}.
                    </span>
                    <span v-else>
                      <strong>
                        <i
                          class="check square outline icon"
                          style="color: darkgreen"
                        ></i>
                      </strong>
                      The <strong>median outcome</strong> sees your money
                      lasting beyond age
                      {{ chartProjections[chartProjections.length - 1].year }}.
                    </span>
                  </span>
                  <span
                    class="ui"
                    v-if="
                      chartProjections && highlightRangeDto == 'Less Likely'
                    "
                  >
                    <span
                      v-if="
                        filter(chartProjections, {
                          balancePessimisticValue2: 0,
                        }).length > 0
                      "
                    >
                      <strong>
                        <i class="x icon" style="color: red"></i>
                      </strong>
                      The
                      <strong>{{ toLowerText(bottomLineLabel) }}</strong> of
                      scenario projections see your money lasting until age
                      {{
                        filter(chartProjections, {
                          balancePessimisticValue2: 0,
                        })[0].year
                      }}.
                    </span>
                    <span v-else>
                      <strong>
                        <i
                          class="check square outline icon"
                          style="color: darkgreen"
                        ></i>
                      </strong>
                      The <strong>lower projected outcome</strong> sees your
                      money lasting beyond age
                      {{ chartProjections[chartProjections.length - 1].year }}.
                    </span>
                  </span>
                  <span
                    class="ui"
                    v-if="
                      chartProjections && highlightRangeDto == 'More Likely'
                    "
                  >
                    <span
                      v-if="
                        filter(chartProjections, {
                          balancePessimisticValue3: 0,
                        }).length > 0
                      "
                    >
                      <strong>
                        <i class="x icon" style="color: red"></i>
                      </strong>
                      The
                      <strong>{{ toLowerText(bottomLineLabel) }}</strong> of
                      scenario projections see your money lasting until age
                      {{
                        filter(chartProjections, {
                          balancePessimisticValue3: 0,
                        })[0].year
                      }}.
                    </span>
                    <span v-else>
                      <strong>
                        <i
                          class="check square outline icon"
                          style="color: darkgreen"
                        ></i>
                      </strong>
                      The
                      <strong>{{ toLowerText(bottomLineLabel) }}</strong> of
                      scenario projections see money lasting beyond age
                      {{ chartProjections[chartProjections.length - 1].year }}.
                    </span>
                  </span>
                  <span v-if="false">
                    <br />
                    <strong>
                      <i
                        class="check square outline icon"
                        style="color: darkgreen"
                      ></i>
                      Risk Profile </strong
                    >. The
                    <strong>
                      {{
                        projectionRequest.accounts[0].portfolios[0].portfolio
                          .portfolioName
                      }}
                    </strong>
                    portfolio is in line with the goal's risk profile.
                  </span>
                </div>
              </div>
            </div>
            <div class="ui row">
              <div class="sixteen wide column">
                <div class="ui">
                  <div class="ui horizontal divider">
                    <span v-if="highlightRangeDto == 'Median'">
                      <span
                        class="box dividr"
                        :style="'opacity: 1;background-color: black '"
                      ></span>
                      Highlights</span
                    >
                    <span v-else-if="highlightRangeDto == 'More Likely'">
                      <span
                        class="box dividr"
                        :style="
                          'opacity:' +
                          appearanceSettings.appearanceSchema
                            .graphColorOpacity +
                          ';background-color: ' +
                          appearanceSettings.appearanceSchema.graphColor
                        "
                      ></span>
                      Highlights</span
                    >
                    <span v-else-if="highlightRangeDto == 'Less Likely'">
                      <span
                        class="box dividr lesslikely"
                        :style="
                          'opacity:' +
                          appearanceSettings.appearanceSchema
                            .graphColorOpacity2 +
                          ';background-color: ' +
                          appearanceSettings.appearanceSchema.graphColorRange2
                        "
                      ></span>
                      Highlights</span
                    >
                  </div>

                  <table class="ui very compact table">
                    <thead>
                      <tr>
                        <th>Year</th>
                        <th style="text-align: center">
                          Cumulative Contributions
                        </th>
                        <th style="text-align: center">
                          Cumulative Withdrawals
                        </th>
                        <th style="text-align: center">Balance</th>
                        <th style="text-align: center">Return*</th>
                      </tr>
                    </thead>
                    <tr>
                      <td>Age {{ chartProjections[1].year }}</td>
                      <td style="text-align: center">
                        {{ shortCurrency
                        }}{{
                          formatNr(chartProjections[1].cumulativeContribution)
                        }}
                      </td>
                      <td style="text-align: center">
                        {{ shortCurrency
                        }}{{ formatNr(chartProjections[1].cumulativeIncome) }}
                      </td>

                      <td style="text-align: center">
                        {{ shortCurrency }}
                        {{
                          formatNr(selectedLineValuesObject.year1BalanceValueP)
                        }}<span v-if="highlightRangeDto != 'Median'">
                          -
                          {{
                            formatNr(
                              highlightLessLikelyRange
                                ? chartProjections[1].balanceOptimisticValue2
                                : chartProjections[1].balanceOptimisticValue3
                            )
                          }}</span
                        >
                      </td>
                      <td style="text-align: center">
                        {{
                          formatNr(
                            selectedLineValuesObject.year1TrrValueP,
                            "0,0.0%"
                          )
                        }}
                        <span v-if="highlightRangeDto != 'Median'">
                          -
                          {{
                            formatNr(
                              highlightLessLikelyRange
                                ? chartProjections[1].trrOptimisticValue2
                                : chartProjections[1].trrOptimisticValue3,
                              "0,0.0%"
                            )
                          }}</span
                        >
                      </td>
                    </tr>
                    <tr v-if="selectedAge">
                      <td>Age {{ selectedAge.year }}</td>
                      <td style="text-align: center">
                        {{ shortCurrency
                        }}{{ formatNr(selectedAge.cumulativeContribution) }}
                      </td>
                      <td style="text-align: center">
                        {{ shortCurrency
                        }}{{ formatNr(selectedAge.cumulativeIncome) }}
                      </td>

                      <td style="text-align: center">
                        {{ shortCurrency }}
                        {{
                          formatNr(
                            selectedLineValuesObject.selectedAgeBalanceValueP
                          )
                        }}
                        <span v-if="highlightRangeDto != 'Median'">
                          -
                          {{
                            formatNr(
                              highlightLessLikelyRange
                                ? selectedAge.balanceOptimisticValue2
                                : selectedAge.balanceOptimisticValue3
                            )
                          }}</span
                        >
                      </td>
                      <td style="text-align: center">
                        {{
                          formatNr(
                            selectedLineValuesObject.selectedAgeTrrValueP,
                            "0.0%"
                          )
                        }}
                        <span v-if="highlightRangeDto != 'Median'">
                          -
                          {{
                            formatNr(
                              highlightLessLikelyRange
                                ? selectedAge.trrOptimisticValue2
                                : selectedAge.trrOptimisticValue3,
                              "0.0%"
                            )
                          }}</span
                        >
                      </td>
                    </tr>
                    <tr v-if="projectionRequest.goalInfo.goalHasTarget">
                      <td>
                        Age
                        {{
                          chartProjections[
                            projectionRequest.goalInfo.goalTargetAge -
                              projectionRequest.currentAge
                          ].year
                        }}
                      </td>
                      <td style="text-align: center">
                        {{ shortCurrency
                        }}{{
                          formatNr(
                            chartProjections[
                              projectionRequest.goalInfo.goalTargetAge -
                                projectionRequest.currentAge
                            ].cumulativeContribution
                          )
                        }}
                      </td>
                      <td style="text-align: center">
                        {{ shortCurrency
                        }}{{
                          formatNr(
                            chartProjections[
                              projectionRequest.goalInfo.goalTargetAge -
                                projectionRequest.currentAge
                            ].cumulativeIncome
                          )
                        }}
                      </td>

                      <td style="text-align: center">
                        {{ shortCurrency }}
                        {{
                          formatNr(
                            selectedLineValuesObject.yearGoalAgeBalanceValueP
                          )
                        }}
                        <span v-if="highlightRangeDto != 'Median'">
                          - {{ shortCurrency }}
                          {{
                            formatNr(
                              highlightLessLikelyRange
                                ? chartProjections[
                                    projectionRequest.goalInfo.goalTargetAge -
                                      projectionRequest.currentAge
                                  ].balanceOptimisticValue2
                                : chartProjections[
                                    projectionRequest.goalInfo.goalTargetAge -
                                      projectionRequest.currentAge
                                  ].balanceOptimisticValue3
                            )
                          }}</span
                        >
                      </td>
                      <td style="text-align: center">
                        {{
                          formatNr(
                            selectedLineValuesObject.yearGoalAgeTrrValueP,
                            "0,0.0%"
                          )
                        }}<span v-if="highlightRangeDto != 'Median'">
                          -
                          {{
                            formatNr(
                              highlightLessLikelyRange
                                ? chartProjections[
                                    projectionRequest.goalInfo.goalTargetAge -
                                      projectionRequest.currentAge
                                  ].trrOptimisticValue2
                                : chartProjections[
                                    projectionRequest.goalInfo.goalTargetAge -
                                      projectionRequest.currentAge
                                  ].trrOptimisticValue3,
                              "0,0.0%"
                            )
                          }}</span
                        >
                      </td>
                    </tr>
                    <tr>
                      <td>
                        Age
                        {{ chartProjections[chartProjections.length - 1].year }}
                      </td>
                      <td style="text-align: center">
                        {{ shortCurrency
                        }}{{
                          formatNr(
                            chartProjections[chartProjections.length - 1]
                              .cumulativeContribution
                          )
                        }}
                      </td>
                      <td style="text-align: center">
                        {{ shortCurrency
                        }}{{
                          formatNr(
                            chartProjections[chartProjections.length - 1]
                              .cumulativeIncome
                          )
                        }}
                      </td>

                      <td style="text-align: center">
                        {{ shortCurrency }}
                        {{
                          formatNr(
                            selectedLineValuesObject.yearLastBalanceValueP
                          )
                        }}
                        <span v-if="highlightRangeDto != 'Median'">
                          -
                          {{
                            formatNr(
                              highlightLessLikelyRange
                                ? chartProjections[chartProjections.length - 1]
                                    .balanceOptimisticValue2
                                : chartProjections[chartProjections.length - 1]
                                    .balanceOptimisticValue3
                            )
                          }}
                        </span>
                      </td>
                      <td style="text-align: center">
                        {{
                          formatNr(
                            selectedLineValuesObject.yearLastTrrValueP,
                            "0,0.0%"
                          )
                        }}
                        <span v-if="highlightRangeDto != 'Median'">
                          -
                          {{
                            formatNr(
                              highlightLessLikelyRange
                                ? chartProjections[chartProjections.length - 1]
                                    .trrOptimisticValue2
                                : chartProjections[chartProjections.length - 1]
                                    .trrOptimisticValue3,
                              "0,0.0%"
                            )
                          }}
                        </span>
                      </td>
                    </tr>
                  </table>

                  <small
                    >(*) annualised
                    <span v-if="highlightRangeDto != 'Median'"
                      >lower and upper range of</span
                    >
                    returns
                    <span v-if="adjustForInflation"
                      >& adjusted for inflation</span
                    ></small
                  ><br />
                </div>
              </div>
            </div>
          </div>
        </div>
      </Section>
    </div>
  </div>
</template>
<script>
import * as _ from "lodash";
import numeral from "numeral";
import {
  DxChart,
  DxSeries,
  DxArgumentAxis,
  DxValueAxis,
  DxCommonAxisSettings,
  DxCommonSeriesSettings,
  DxGrid,
  DxMargin,
  DxLegend,
  DxTick,
  DxTooltip,
  DxCrosshair,
  DxLabel,
  DxConstantLine,
  DxFont,
} from "devextreme-vue/chart";
import AnimatedNumber from "@/components/AnimatedNumber.vue";
import { toLower } from "lodash";

export default {
  name: "ChartProjectedBalances",
  props: {
    shortCurrency: String,
    currency: String,
    appearanceSettings: Object,
    showLowestProjectedOutcome: Boolean,
    showDisclaimer: Boolean,
    colors: Object,
    chartProjections: Array,
    currentAge: Number,
    // selectedPoint: Object,
    show: Boolean,

    hasAdhocCashFlow: Boolean,
    projectionRequest: Object,
    adjustForInflation: Boolean,
    moreLikelyZScore: Number,
    lessLikelyZScore: Number,
    highlightRangeDto: String,
  },
  components: {
    AnimatedNumber,
    DxChart,
    DxSeries,
    DxArgumentAxis,
    DxValueAxis,
    DxConstantLine,
    DxCommonAxisSettings,
    DxCommonSeriesSettings,
    DxGrid,
    DxMargin,
    DxLabel,
    DxLegend,
    DxTick,
    DxTooltip,
    DxCrosshair,
    DxFont,
  },
  data() {
    return {
      zScores: [
        { text: "1%", value: 2.5758 },
        { text: "5%", value: 1.96 },
        { text: "10%", value: 1.6449 },
        { text: "15%", value: 1.4395 },
        { text: "25%", value: 1.1503 },
        { text: "40%", value: 0.8416 },
        { text: "45%", value: 0.7554 },
      ],
      ranges: ["Median", "More likely", "Less likely"],

      highlightLessLikelyRange: false,
      showRange: "More likely",
      hideOptimistic: false,
      onlyShowMoreLikelyOutcomes: false,
      selectedPoint: {
        index: 0,
        age: 0,
        balance: 0,
        balanceOptimisticValue: 0,
        balanceOptimisticValue2: 0,
        balanceOptimisticValue3: 0,
        balancePessimisticValue: 0,
        balancePessimisticValue2: 0,
        balancePessimisticValue3: 0,
      },
    };
  },
  watch: {
    onlyShowMoreLikelyOutcomes() {
      var r = [];
      r = this.chartProjections;
      this.chartProjections = [];
      this.chartProjections = r;
    },
  },
  computed: {
    adhocCashFlows: function () {
      /*projectionRequest.getIncomeCashFlowRequest.adhocCashFlow1
       */

      if (this.projectionRequest.additionalGetIncomeCashFlowRequests) {
        return this.projectionRequest.additionalGetIncomeCashFlowRequests[0];
      } else {
        return this.projectionRequest.getIncomeCashFlowRequest;
      }
    },

    moreLikelyText() {
      return _.find(this.zScores, ["value", this.moreLikelyZScore]).text;
    },
    lessLikelyText() {
      return _.find(this.zScores, ["value", this.lessLikelyZScore]).text;
    },
    bottomLineLabel() {
      if (this.highlightRangeDto == "Median") return "Median";
      else if (this.highlightRangeDto == "Less Likely")
        return "Bottom " + this.lessLikelyText;
      else return "Bottom " + this.moreLikelyText;
    },
    bottomLineValue() {
      if (this.highlightRangeDto == "Median") return "balance";
      else if (this.highlightRangeDto == "Less Likely")
        return "balancePessimisticValue2";
      else return "balancePessimisticValue3";
    },
    selectedLineValuesObject() {
      if (this.highlightRangeDto == "Median") {
        return {
          goalTargetPercentage:
            this.projectionRequest.goalInfo.goalTargetAge -
              this.projectionRequest.currentAge >
            0
              ? this.chartProjections[
                  this.projectionRequest.goalInfo.goalTargetAge -
                    this.projectionRequest.currentAge
                ].goalTargetPercentage
              : 0,
          year1BalanceValueP: this.chartProjections[1].balance,
          year1TrrValueP: this.chartProjections[1].trr,
          yearGoalAgeBalanceValueP:
            this.projectionRequest.goalInfo.goalTargetAge -
              this.projectionRequest.currentAge >
            0
              ? this.chartProjections[
                  this.projectionRequest.goalInfo.goalTargetAge -
                    this.projectionRequest.currentAge
                ].balance
              : 0,
          yearGoalAgeTrrValueP:
            this.projectionRequest.goalInfo.goalTargetAge -
              this.projectionRequest.currentAge >
            0
              ? this.chartProjections[
                  this.projectionRequest.goalInfo.goalTargetAge -
                    this.projectionRequest.currentAge
                ].trr
              : 0,
          selectedAgeBalanceValueP: this.selectedAge.balance,
          selectedAgeTrrValueP: this.selectedAge.trr,
          yearLastBalanceValueP: this.chartProjections[
            this.chartProjections.length - 1
          ].balance,
          yearLastTrrValueP: this.chartProjections[
            this.chartProjections.length - 2
          ].trr,
        };
      } else if (this.highlightRangeDto == "Less Likely") {
        return {
          goalTargetPercentage:
            this.projectionRequest.goalInfo.goalTargetAge -
              this.projectionRequest.currentAge >
            0
              ? this.chartProjections[
                  this.projectionRequest.goalInfo.goalTargetAge -
                    this.projectionRequest.currentAge
                ].goalTargetPercentagePessimisticValue2
              : 0,
          year1BalanceValueP: this.chartProjections[1].balancePessimisticValue2,
          year1TrrValueP: this.chartProjections[1].trrPessimisticValue2,
          yearGoalAgeBalanceValueP:
            this.projectionRequest.goalInfo.goalTargetAge -
              this.projectionRequest.currentAge >
            0
              ? this.chartProjections[
                  this.projectionRequest.goalInfo.goalTargetAge -
                    this.projectionRequest.currentAge
                ].balancePessimisticValue2
              : 0,
          yearGoalAgeTrrValueP:
            this.projectionRequest.goalInfo.goalTargetAge -
              this.projectionRequest.currentAge >
            0
              ? this.chartProjections[
                  this.projectionRequest.goalInfo.goalTargetAge -
                    this.projectionRequest.currentAge
                ].trrPessimisticValue2
              : 0,
          selectedAgeBalanceValueP: this.selectedAge.balancePessimisticValue2,
          selectedAgeTrrValueP: this.selectedAge.trrPessimisticValue2,
          yearLastBalanceValueP: this.chartProjections[
            this.chartProjections.length - 1
          ].balancePessimisticValue2,
          yearLastTrrValueP: this.chartProjections[
            this.chartProjections.length - 1
          ].trrPessimisticValue2,
        };
      } else if (this.highlightRangeDto == "More Likely") {
        return {
          goalTargetPercentage:
            this.projectionRequest.goalInfo.goalTargetAge -
              this.projectionRequest.currentAge >
            0
              ? this.chartProjections[
                  this.projectionRequest.goalInfo.goalTargetAge -
                    this.projectionRequest.currentAge
                ].goalTargetPercentagePessimisticValue3
              : 0,
          year1BalanceValueP: this.chartProjections[1].balancePessimisticValue3,
          year1TrrValueP: this.chartProjections[1].trrPessimisticValue3,
          yearGoalAgeBalanceValueP:
            this.projectionRequest.goalInfo.goalTargetAge -
              this.projectionRequest.currentAge >
            0
              ? this.chartProjections[
                  this.projectionRequest.goalInfo.goalTargetAge -
                    this.projectionRequest.currentAge
                ].balancePessimisticValue3
              : 0,
          yearGoalAgeTrrValueP:
            this.projectionRequest.goalInfo.goalTargetAge -
              this.projectionRequest.currentAge >
            0
              ? this.chartProjections[
                  this.projectionRequest.goalInfo.goalTargetAge -
                    this.projectionRequest.currentAge
                ].trrPessimisticValue3
              : 0,
          selectedAgeBalanceValueP: this.selectedAge.balancePessimisticValue3,
          selectedAgeTrrValueP: this.selectedAge.trrPessimisticValue3,
          yearLastBalanceValueP: this.chartProjections[
            this.chartProjections.length - 1
          ].balancePessimisticValue3,
          yearLastTrrValueP: this.chartProjections[
            this.chartProjections.length - 1
          ].trrPessimisticValue3,
        };
      } else
        return {
          goalTargetPercentage: 0,
          year1BalanceValueP: 0,
          year1TrrValueP: 0,
          yearGoalAgeBalanceValueP: 0,
          yearGoalAgeTrrValueP: 0,
          selectedAgeBalanceValueP: 0,
          selectedAgeTrrValueP: 0,
          yearLastBalanceValueP: 0,
        };
    },

    selectedAge: function () {
      if (this.selectedPoint.age > 0) {
        if (this.chartProjections[this.selectedPoint.index + 1])
          return this.chartProjections[this.selectedPoint.index + 1];
        else return this.chartProjections[1];
      } else if (this.chartProjections[1]) {
        return this.chartProjections[1];
      } else return null;
    },
    /* chartProjections: function() {
      var final = [];
      console.log("chartProjections start");
      if (this.chartProjections.length > 0) {
        for (var i = 0; i < this.chartProjections.length; i++) {
          var cp = this.chartProjections[i];
          var inflationRate = 0.055;
          if (!this.adjustForInflation) inflationRate = 0;

          cp.balanceAdjust = cp.balance / Math.pow(1 + inflationRate, i + 1);
          cp.balanceOptimisticValue2 =
            cp.balanceOptimisticValue2 / Math.pow(1 + inflationRate, i + 1);
          cp.balanceOptimisticValue3 =
            cp.balanceOptimisticValue3 / Math.pow(1 + inflationRate, i + 1);

          cp.balanceOptimisticValue =
            cp.balanceOptimisticValue / Math.pow(1 + inflationRate, i + 1);
          cp.balancePessimisticValue2 =
            cp.balancePessimisticValue / Math.pow(1 + inflationRate, i + 1);
          cp.balancePessimisticValue3 =
            cp.balancePessimisticValue3 / Math.pow(1 + inflationRate, i + 1);
          cp.balancePessimisticValue =
            cp.balancePessimisticValue / Math.pow(1 + inflationRate, i + 1);
          cp.cumulativeContributionAdjust =
            cp.cumulativeContribution / Math.pow(1 + inflationRate, i + 1);
          cp.cumulativeIncomeAdjust =
            cp.cumulativeIncome / Math.pow(1 + inflationRate, i + 1);

          final.push(cp);
        }
      }
      console.log("chartProjections end", final.length);
      return final;
    },*/
  },
  methods: {
    toLowerText(val) {
      return toLower(val);
    },
    getSeriesByName(seriesName) {
      return this.$refs.chart.instance.getSeriesByName(seriesName);
    },
    highlightRange(val) {
      if (val == "More Likely") {
        this.highlightLessLikelyRange = false;
      } else {
        this.highlightLessLikelyRange = true;
      }

      this.highlightRangeDto = val;
      this.adjustHighlightRangeDto(val);
      //this.adjustInflation();
    },
    clickDisclaimer() {
      this.showDisclaimer = true;
      this.$emit("handleSelected", {
        showDisclaimer: this.showDisclaimer,
      });
    },
    adjustInflation() {
      this.$emit("handleInflationChanged", {
        adjustForInflation: this.adjustForInflation,
      });
    },
    adjustHighlightRangeDto() {
      this.$emit("handleHighlightRangeDtoChanged", {
        highlightRangeDto: this.highlightRangeDto,
      });
    },
    exportChart() {
      this.$refs.chart.instance.exportTo("ProjectedBalances", "png");
    },
    map: function (arr, obj) {
      return _.map(arr, _.partialRight(_.pick, obj));
    },
    flatten: function (arr) {
      return _.flattenDeep(arr);
    },
    filter: function (arr, filtr) {
      return _.filter(arr, filtr);
    },
    take: function (arr, size) {
      return _.take(arr, size);
    },
    formatNr(val, fmt) {
      if (fmt) return numeral(val).format(fmt);
      else return numeral(val).format("0,0.0a");
    },
    customizePoint() {
      return {
        visible: false,
        color: "#ff7c7c",
        hoverStyle: { color: "#ffffff" },
      };
    },
    customizeTooltipBalances2(arg) {
      // console.log("customizeTooltipBalances2", arg);
      var indexP = arg.argument - this.chartProjections[0].year;

      // console.log("indexP", indexP);

      this.selectedPoint.index = indexP - 1;
      // console.log("this.selectedPoint.index", this.selectedPoint.index);

      return {
        html: ``,
      };
    },
    customizeTooltipBalances(arg) {
      var indexP = arg.argument - this.chartProjections[0].year;

      this.selectedPoint.index = indexP - 1;

      if (this.chartProjections[indexP - 1]) {
        var median = numeral(this.chartProjections[indexP - 1].balance).format(
          "0,00.0a"
        );
        /*  var sixty = numeral(
          this.chartProjections[indexP - 1].balancePessimisticValue3
        ).format("0,00.0a");
        var sixty2 = numeral(
          this.chartProjections[indexP - 1].balanceOptimisticValue3
        ).format("0,00.0a");

        var eighty2 = numeral(
          this.chartProjections[indexP - 1].balanceOptimisticValue
        ).format("0,00.0a");
*/
        var eighty = numeral(
          this.chartProjections[indexP - 1].balancePessimisticValue
        ).format("0,00.0a");
        return {
          html: `<div><div class='tooltip-header'>Projected Balances at ${arg.argument}</div>
    <table class="ui   striped table"><tr><td>Average</td><td><strong>R${median}</strong></td></tr>
    <tr><td>Low Projection</td><td><strong>R${eighty}</strong></td></tr></table>
    * Click here for how projections are calculated
        `,
        };
      }
    },
  },
  async mounted() {
    if (this.chartProjections)
      this.selectedPoint = {
        index: 0,
        age: this.chartProjections[0].year,
      };
  },
};
</script>
<style scoped>
.box {
  float: left;
  height: 10px;
  width: 10px;
  margin-top: 4px;
  margin-right: 2px;
  background-color: #006900;

  border: 0px solid black;
  clear: both;
}

.lesslikely {
  background-color: green;
}

.big {
  margin-top: 3px;
  height: 14px;
  width: 14px;
  border: 1px solid black;
}

.dividr {
  margin-top: 0px;
  height: 14px;
  width: 14px;
  border: 1px solid black;
}

.bhead {
  margin-top: 5px;
  margin-right: 5px;
  height: 20px;
  width: 20px;
  border: 2px solid black;
}

.selectable {
  cursor: pointer;
}

.unselected {
  font-weight: 100;
}

.selected {
  color: black;
  font-weight: bold;
  cursor: auto;
}
</style>
